"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = AlignRight;
var _AlignRight = require("@adobe/react-spectrum-workflow/dist/AlignRight.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function AlignRight(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_AlignRight.A4uAlignRight, null));
}